import React, {FC, useCallback, useState} from 'react'
import {
  initialToast,
  NotificationsContext,
  NotificationsContextInterface,
  UserNotificationsResponse, ToastProps,
} from '../types'
import {useQuery} from 'react-query'
import {Get} from '../../../setup'
import {LoadingState} from '../../../global'


const endpoint = process.env.REACT_APP_NOTIFICATIONS || 'notifications'

const NotificationsProvider: FC = ({children}) => {

  const [userNotifications, setUserNotifications] = useState<Partial<UserNotificationsResponse>>({
    ticket_message: {
      count: 0,
      data: [],
    },
  })
  const [loading, setLoading] = useState<LoadingState>('idle')
  const [toast, setToast] = useState<ToastProps>(initialToast)

  const {refetch} = useQuery(
    'NOTIFICATIONS',
    () => Get<UserNotificationsResponse>({endpoint}), {
      onSuccess: (data) => {
        setLoading('fulfilled')
        setUserNotifications(data)
      },
    })

  const refreshNotifications = useCallback(() => {
    refetch()
  }, [refetch])

  const contextValue: NotificationsContextInterface = {
    loading,
    setLoading,
    refetch,
    toast,
    setToast,
    userNotifications,
    refreshNotifications,
  }

  return (
    <NotificationsContext.Provider value={contextValue}>
      {children}
    </NotificationsContext.Provider>
  )
}

export {NotificationsProvider}